var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-6"},[_c('input-radio-boolean',{staticClass:"flex items-center",attrs:{"label":"Send notifications for new deals?","name":_vm.name,"value":_vm.value,"true":"Yes","false":"No"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }